<form class="form-signin change-password" [formGroup]="appValForm" (ngSubmit)="Save()">
  <div class="text-center">
    <img class="mb-4 w-50" src="assets/images/JT_signin_Logo.gif" alt="{{'Login.JobtrainLogin'|translate}}">
  </div>

  <div class="h5 text-danger text-center">{{ 'Login.YourPasswordNotSecure' | translate }}</div>
  {{ 'Login.PasswordSecurePara1' | translate }}<br />
  {{ 'Login.PasswordSecurePara2' | translate }}<br />
  {{ 'Login.PasswordSecurePara3' | translate }}<br />
  {{ 'Login.PasswordSecurePara4' | translate }}<br /><br />

  <div>
    <input type="text"
      formControlName="userName"
      readonly="readonly"
      [ngClass]="{ 'is-invalid': submittedForm && controls.userName.errors }"
      class="form-control"
      data-test-id="txt-user-name">
    </div>

    <div>
      <input type="password"
        formControlName="oldPassword"
        maxlength="25"
        class="form-control inputfield"
        placeholder="{{ 'UserSettings.Create.OldPassword' | translate }}"
        [ngClass]="{ 'is-invalid': submittedForm && controls.oldPassword.errors }"
        data-test-id="txt-old-password" />
      </div>

      <div>
        <input type="password"
          formControlName="password"
          maxlength="25"
          class="form-control"
          placeholder="{{ 'UserSettings.Create.NewPassword' | translate }}"
          [ngClass]="{ 'is-invalid': submittedForm && controls.password.errors }"
          data-test-id="txt-new-password">



        </div>

        <div class="mt-2">
          <input type="password"
            formControlName="confirmPassword"
            class="form-control"
            placeholder="{{ 'UserSettings.Create.RetypePassword' | translate }}"
            data-test-id="txt-confirm-password"
            [ngClass]="{ 'is-invalid': submittedForm && (controls.confirmPassword.errors || appValForm.errors?.passwordMismatch) }">


            @if (submittedForm && appValForm.errors?.passwordMismatch) {
              <div class="text-left">
                <label class="text-danger">{{ 'Common.Passworddoesnotmatch' | translate }}</label>
              </div>
            }

            @if (isPasswordBreached) {
              <div class="text-left" data-test-id="div-password-instruction">
                <app-pwned-password-instructions></app-pwned-password-instructions>
              </div>
            }
          </div>

          <div class="mt-2">
            <button class="btn btn-lg btn-primary btn-block btn_submit" type="submit">
              {{ 'Login.ChangePasswordAndSignIn' | translate }}
            </button>
          </div>

          <div class="mt-2">
            <button type="button" class="btn btn-lg btn-outline-success btn-block" (click)="SignOut()" data-test-id="lnk-sign-out">
              {{ 'Common.SignOut' | translate }}
            </button>
          </div>


          <br />
          <div class="password-strength" data-test-id="div-password-strength">
            @if (controls.password.value) {
              <ng9-password-strength-bar
                [passwordToCheck]="controls.password.value"
                (onStrengthChanged)="strengthChanged()">
              </ng9-password-strength-bar>
            }
          </div>

          <label class="text-danger text-left">{{ common?.message }}</label>
          <br />
          <p class="text-muted">&copy; {{ 'Login.Footer' | translate }}</p>
        </form>
